<template>
  <div id="center">
    <div class="d-flex pt-2 pl-2 mar">
      <span>
        <icon name="chart-pie" class="text-icon"></icon>
      </span>
      <div class="d-flex">
        <span class="fs-xl text mx-2">会员</span>
      </div>
    </div>
    <div class="up">
      <div class="bg-color-black item" v-for="(item,index) in titleItem" :key="index">
        <p class="tits colorBlue fw-b">{{ item.name }}</p>
        <div class="numbers">{{item.value}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        titleItem: [],
      }
    },
    components: {},
    created() {

    },
    mounted() {
      this.getdata()
    },
    methods: {
      async getdata() {
        let res = await this.ajax('/report/getLevelReport')
        this.titleItem = res.data
      },
    },
    watch: {

    }
  }
</script>

<style lang="scss" scoped>
  #center {
    display: flex;
    flex-direction: column;

    .mar {
      margin-top: 18px;
      margin-left: 10px;
    }

    .up {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      padding: 0 13px;
      margin-bottom: 20px;

      .item {
        border-radius: 6px;
        padding-top: 8px;
        margin-top: 8px;
        width: calc(100% / 6 - 10px);


        .tits {
          text-align: center;
        }

        .numbers {
          color: #7ec699;
          font-size: 26px;
          font-weight: 700;
          text-align: center;
          padding: 12px 0;
        }
      }
    }


  }
</style>